"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _SortingDropdown = _interopRequireDefault(require("./SortingDropdown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var ThreadedRepliesHeader = function ThreadedRepliesHeader(_ref) {
  var type = _ref.type,
      currentSort = _ref.currentSort,
      totalReplies = _ref.totalReplies,
      isTranslationInProgress = _ref.isTranslationInProgress;
  return (0, _preact.h)("header", {
    className: "list__items--header qa-topic-reply-box-header"
  }, (0, _preact.h)("div", {
    className: "topic-replies__header--left"
  }, (0, _preact.h)("h2", {
    className: "qa-total-replies"
  }, (0, _preact.h)(_phrase.default, {
    p: totalReplies ? '{n} Reply|{n} Replies' : 'no.replies',
    count: {
      n: totalReplies.toString()
    }
  }))), (0, _preact.h)("nav", {
    className: "topic-replies__header-item-list",
    "aria-live": "polite",
    "aria-busy": isTranslationInProgress
  }, (0, _preact.h)(_SortingDropdown.default, {
    totalReplies: totalReplies,
    type: type,
    currentSort: currentSort
  })));
};

var _default = ThreadedRepliesHeader;
exports.default = _default;